import { render, staticRenderFns } from "./PanelCandidatesTab.vue?vue&type=template&id=ffe80fa8&scoped=true"
import script from "./PanelCandidatesTab.vue?vue&type=script&lang=js"
export * from "./PanelCandidatesTab.vue?vue&type=script&lang=js"
import style0 from "./PanelCandidatesTab.vue?vue&type=style&index=0&id=ffe80fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe80fa8",
  null
  
)

export default component.exports